import tippy from 'tippy.js';
import 'lazysizes';
import '@/boot/bugsnag.js';
import '@/boot/asset-loaders.js';
import '@/boot/global.js';
import '@/boot/session.js';
import '@/boot/ui-helpers.js';
import '@/boot/polyfills.js';
import 'apps/navigation';
import Alpine from 'alpinejs';
import focus from '@alpinejs/focus';
import collapse from '@alpinejs/collapse';
import intersect from '@alpinejs/intersect';
import mask from '@alpinejs/mask';
import wizard from '@glhd/alpine-wizard';
import ajax from '@imacrayon/alpine-ajax';
import InterNACHI from "shared/InterNACHI.js";
import route from '@/shared/ziggy.js';
import { AlpineRoute } from '@/boot/route-plugin.js';
import translate, { trans_choice } from '@/shared/i18n/translator.js';

// Add globals
window.Alpine = Alpine;
window.tippy = tippy;
window.route = route;
window.__ = translate; // oxlint-disable-line no-underscore-dangle -- mirrors Laravel's __() helper
window.trans_choice = trans_choice;

// Set up Alpine
Alpine.plugin(focus);
Alpine.plugin(collapse);
Alpine.plugin(intersect);
Alpine.plugin(mask);
Alpine.plugin(wizard);
Alpine.plugin(ajax);
Alpine.plugin(AlpineRoute(route));
window.addEventListener('DOMContentLoaded', () => Alpine.start());

InterNACHI.session.onGuest(() => {
	document.documentElement.classList.add('logged-out');
	document.documentElement.classList.remove('logged-in', 'authenticating');
});

InterNACHI.session.onLoaded(() => {
	document.documentElement.classList.add('logged-in');
	document.documentElement.classList.remove('logged-out', 'authenticating');
});

document.addEventListener('DOMContentLoaded', () => tippy('[data-tippy-content]'));
